import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'regenerator-runtime/runtime';
import { ErrorBoundary } from './components/Shared';
import { getBuddiRegion } from './config';
import { ThemeProvider } from './context';
import { routes } from './routes';
import { FeatureLogger } from './services';
import { setDefaultRegion } from './services/buddiService';
import { store } from './store';

// TODO: Call initializeBuddi() here to load a bunch of most used URLs
setDefaultRegion(getBuddiRegion());

axios.defaults.headers.common = { 'content-type': 'application/json' };
axios.defaults.responseType = 'json';
const responseInterceptor = axios.interceptors.response.use(
  async value => value,
  async error => {
    axios.interceptors.response.eject(responseInterceptor);
    FeatureLogger.markException(error.response);
    return Promise.reject(error);
  }
);

const renderApp = async () => {
  const baseUrl = document
    .getElementsByTagName('base')[0]
    .getAttribute('href')!;

  ReactDOM.render(
    <ThemeProvider>
      <ErrorBoundary>
        <AppContainer>
          <Provider store={store}>
            <BrowserRouter children={routes} basename={baseUrl} />
          </Provider>
        </AppContainer>
      </ErrorBoundary>
    </ThemeProvider>,
    document.getElementById('react-app')
  );
};

renderApp().catch(error => console.error(error));

if (module.hot) {
  module.hot.accept('./routes', async () => renderApp());
}
